import { useSelector } from "react-redux";
import { Box, Typography, Chip, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { selectMainStrategy } from "../../../../Redux/Reducers/strategyStoreSlice";
import { useParams } from "react-router-dom";
import ComparePanel from "./ComparePanel";

const StrategyHeader = () => {
  const theme = useTheme();
  const mainStrategy = useSelector(selectMainStrategy);
  const { slug, ownerSlug } = useParams();

  const hasTags = Array.isArray(mainStrategy?.tags) && mainStrategy.tags.length > 0;
  const hasCategories = Array.isArray(mainStrategy?.categories) && mainStrategy.categories.length > 0;

  return (
    <Box display="flex" alignItems="flex-start" justifyContent="space-between" gap={2}>
      <Box flex={1}>
        <Typography variant="h2" gutterBottom>
          {mainStrategy?.title}
        </Typography>

        {(hasTags || hasCategories) && (
          <Box display="flex" alignItems="center" gap={2} mb={2} flexWrap="wrap">
            {hasCategories && (
              <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                <Typography variant="caption" color="text.secondary">Category:</Typography>
                {mainStrategy.categories.map((category) => (
                  <Chip
                    key={category}
                    label={category}
                    size="small"
                    variant="outlined"
                    color="primary"
                    sx={{
                      backgroundColor: alpha(theme.palette.primary.main, 0.12),
                      "& .MuiChip-label": { color: "#fff", fontSize: "0.9rem" },
                    }}
                  />
                ))}
              </Box>
            )}
            {hasTags && (
              <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                <Typography variant="caption" color="text.secondary">Tags:</Typography>
                {mainStrategy.tags.map((tag) => (
                  <Chip
                    key={tag}
                    label={tag}
                    size="small"
                    variant="outlined"
                    sx={{
                      borderColor: "#2e7d32",
                      backgroundColor: "rgba(46,125,50,0.12)",
                      "& .MuiChip-label": { color: "#fff", fontSize: "0.9rem" },
                    }}
                  />
                ))}
              </Box>
            )}
          </Box>
        )}

        <Typography
          color="text.secondary"
          mb={3}
          variant="subtitle2"
          sx={{ marginY: "2rem" }}
        >
          {mainStrategy?.description}
        </Typography>
      </Box>
      <ComparePanel ownerSlug={ownerSlug} mainSlug={slug} />
    </Box>
  );
};

export default StrategyHeader;
